import styled from "styled-components";
import ReviewItem from "./ReviewItem";

function Review(){
    return(
        <Container>
            <PartName>고객 만족 후기</PartName>
            <ReviewList>
                <ReviewItem title={"처음부터 끝까지 도와주세요!"}
                    content={"이끌어주는 리더가 있다는 것, 함께 쓰는 사람이 있다는 것, 그것만으로 글이 되고 책이 됩니다.함께 글쓰고 몇주간 줌에 참여한 사람들끼리 출간기념 모임을 해도 좋겠습니다.책이 되어 세상에 나온다니 이 감격을 함께 나누고 싶네요!"}
                    writer={"김**  고객님의 이용 후기"}
                />
                <ReviewItem title={"역시 프로 작가는 다른것 같아요"}
                    content={"혼자 하는 것이 아니라 등단 작가님과 함께라 더욱 완성도 높은 글이 나옵니다. 4주 동안의 과정에서 창작이라는 고민을 함께 나누고, 책의 발행 과정의 행복함을 느낄 수 있게 되어 너무 좋았습니다."}
                    writer={"조**  고객님의 이용 후기"}
                />
                <ReviewItem title={"나의 이야기를 전한다는 것"}
                    content={"내가 살아오면서 느낀 경험을 글로 녹여내는 방법을 배웠습니다. 그리고 작성한 글을 책으로까지 발행하는 과정을 통해 단순한 문자가 아닌 ‘작품’이 되어 간직할 수 있다는 기분을 느끼게 해 줬습니다."}
                    writer={"박**  고객님의 이용 후기"}
                />
            </ReviewList>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 60px;
`


const PartName = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #58AC65;
`


const ReviewList = styled.div`
    display: grid;
    justify-content: space-between;
    gap: 30px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export default Review;